
export const setAPIErrorAction = err => {
  return {
    type: 'SET_API_ERROR',
    data: err,
  };
};
